import React,{Component} from 'react';
import { Link } from 'react-router-dom';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Api from "../../../libraries/api";
import user from "../../../images/user.png";
import Button from '@material-ui/core/Button';
import {toast, ToastContainer} from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../presentational/table-pagination-actions";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {history} from "../../../shared/configure-store";
import CommonHelper from '../../../libraries/common-helper';
import AuthHelper from '../../../libraries/auth-helper';

require('dotenv').config();

class Users extends Component {
    _isMounted = false;

    constructor(props) {

        let currentDate = new Date();

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            permissions: [],

            orderBy: '',
            sortedBy: '',
            searchBy: '',
            filterIsActive: '',
            filterRole: '',

            roles: [],
            showDialog: false,
            idDelete: '',
            currDelete: '',

            nik: '',
            fullName: '',
            email: '',
            password: '',
            position: '',
            phone: '',
            address: '',
            birthCity: '',
            bod: currentDate.getFullYear() + '-' + appendLeadingZeroes(currentDate.getMonth() + 1) + '-' + appendLeadingZeroes(currentDate.getDate()),
            roleId: '',
            is_active: false,

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,

            isEdit: false,
            isDelete: false,
            isCreate: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Abadi - Admin';
        let permissions = AuthHelper.getProfile()?.permissions;

        this.setState({ permissions });

        this.__fetchData(false);
        this.__fetchRoles();

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    __fetchData = update => {
        this._isMounted = true;

        let page = update ? parseInt(this.state.currentPage + 1) : this.state.currentPage;

        let sort = this.state.orderBy ? '&orderBy=' + this.state.orderBy + '&sortedBy=' + this.state.sortedBy : '';
        let search = this.state.searchBy ? '&search=' + this.state.searchBy : '';
        let filterIsActive = this.state.filterIsActive ? '&is_active=' + this.state.filterIsActive : '';
        let filterRole = this.state.filterRole ? '&role=' + this.state.filterRole : '';

        let route = '';

        if(search) {
            route = '/users?limit='+this.state.perPage+sort+search+filterIsActive+filterRole;
        }else {
            route = '/users?limit='+this.state.perPage+'&page='+page+sort+search+filterIsActive+filterRole;
        }

        Api.get(route).then(resp => {
            if (this._isMounted) {

                if (resp.data) {

                    this.setState({
                        rows: resp.data,
                        perPage: resp.meta.pagination.per_page,
                        currentPage: resp.meta.pagination.current_page,
                        currentPageTable: resp.meta.pagination.current_page - 1,
                        total: resp.meta.pagination.total,
                        loading: false,
                        isEdit: resp.meta.custom.isEdit,
                        isDelete: resp.meta.custom.isDelete,
                        isCreate: resp.meta.custom.isCreate,
                    })

                }
            }
        }).catch(err => {
            console.log(err);
        });
    };

    __fetchRoles = () => {
        Api.get('/roles?limit=0').then(resp => {
            if (resp.data) {
                let data = resp.data.map((o) => ({ label: o.display_name, value: o.display_name }));
                this.setState({ roles: data });
            }
        });
    };

    handleSearch = () => {
        this.__fetchData(false);
    };
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };
    handleFilter (e, prop){
        this.setState({ [prop]: e.target.value }, () => {
            this.__fetchData(false);
        });
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if(val !== this.state.orderBy){
            sortedBy = 'asc';
        }else{
            if(sortedBy && sortedBy === 'asc' ){
                sortedBy = 'desc';
            }else{
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleOpen = (row) => {
        this.setState({
            showDialog :true,
            idDelete: row.id,
            currDelete: row.name,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog :false,
        })
    };

    handleDelete = () => {

        if(this.state.idDelete) {
            Api.delete('/users/'+this.state.idDelete, '', false).then(resp => {

                this.setState({
                    showDialog: false,
                    }
                );

                this.showMessage(true, 'User successfully deleted');
                this.__fetchData(false);

            }).catch(err => {

                this.setState({
                    showDialog: false
                    }
                );

                this.showMessage(true, 'User successfully deleted');
                this.__fetchData(false);
            });
        }
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage:newPage,
            currentPageTable:newPage,
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage:parseInt(event.target.value, 10),
            currentPage:1,
            loading: true,
        },() => {
            this.__fetchData(false);
        });
    };

    handleGo  = (link) => {

        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Admin</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Admin</li>
                        </ol>
                    </nav>

                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <div className="row align-items-center mb-md-3">
                            <div className="col-md-3">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton
                                                    aria-label="Search click"
                                                    onClick={this.handleSearch}
                                                >
                                                    <i className="fas fa-search"> </i>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    fullWidth
                                />
                            </div>
                            <div className="col-md-3">
                                <TextField
                                    className="search-field"
                                    label="Role"
                                    variant="outlined"
                                    id="filterRole"
                                    name="filterRole"
                                    onChange={(e) => this.handleFilter(e, 'filterRole')}
                                    value={this.state.filterRole}
                                    fullWidth
                                    select
                                >
                                    <MenuItem key="" value="">All</MenuItem>
                                    {this.state.roles.map(option => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
                                </TextField>
                            </div>
                            <div className="col-md-3">
                                <TextField
                                    className="search-field"
                                    label="Status"
                                    variant="outlined"
                                    id="filterIsActive"
                                    name="filterIsActive"
                                    onChange={(e) => this.handleFilter(e, 'filterIsActive')}
                                    value={this.state.filterIsActive}
                                    fullWidth
                                    select
                                >
                                    <MenuItem key="" value="">All</MenuItem>
                                    <MenuItem key="1" value="1">Active</MenuItem>
                                    <MenuItem key="0" value="0">Inactive</MenuItem>
                                </TextField>
                            </div>
                            <div className="col-md-3 text-md-right">
                                {CommonHelper.checkPermission(this.state.permissions, 'create-users') && (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className="mb-3 mb-md-0"
                                        onClick={() => this.handleGo('/users/add')}
                                    >
                                        Create Admin
                                    </Button>
                                )}
                                {this.state.isCreate &&
                                <Link to="/users/add" className="btn btn-blue">ADD USER</Link>
                                }
                            </div>
                        </div>

                        <Table className="table-list" size="small" >
                            <TableHead>
                                <TableRow>
                                    <TableCell className="clickable" onClick={() => this.handleSort('name')} >Name
                                        {this.state.orderBy === 'name' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('email')} >Email
                                        {this.state.orderBy === 'email' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell>Role</TableCell>
                                    <TableCell>Additional Roles</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.loading ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" className="py-5">
                                            <CircularProgress color="primary"  />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage}}>
                                            <TableCell colSpan={5} style={{ textAlign: "center" }}>No users</TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.map(row => (
                                            <TableRow
                                                key={row.id}
                                                selected={row.selected}>
                                                <TableCell>
                                                    <img src={row.avatar === null ? user : process.env.REACT_APP_API_STORAGE_PATH+row.avatar} alt='avatar' className="img-user mr-2" />
                                                    <span>{row.name === null ? '' : row.name}</span>
                                                </TableCell>
                                                <TableCell>{row.email === null ? '' : row.email}</TableCell>
                                                <TableCell>{row.role === null ? '' : row.role}</TableCell>
                                                <TableCell>{row.additional_roles === null || row.additional_roles === 'undefined' ? '' : row.additional_roles}</TableCell>
                                                <TableCell>{row.is_active === 1 ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Inactive</span>}</TableCell>
                                                <TableCell>
                                                    <div className="d-flex justify-content-center">
                                                        {CommonHelper.checkPermission(this.state.permissions, 'update-users') && (
                                                            <Link to={"/users/edit/" + row.id} className="btn-icon mr-2">
                                                                <i className="fas fa-edit"> </i>
                                                            </Link>
                                                        )}
                                                        {CommonHelper.checkPermission(this.state.permissions, 'delete-users') && (
                                                            <button className="btn-icon" onClick={() => this.handleOpen(row)}>
                                                                <i className="fas fa-trash-alt"> </i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )
                                )}

                            </TableBody>
                        </Table>
                    </div>

                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50]}
                        component="div"
                        count={this.state.total}
                        rowsPerPage={this.state.perPage}
                        page={this.state.currentPageTable}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />

                </div>

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">DELETE USER: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wanna delete this user?</p>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleClose}>
                            Cancel
                        </button>
                        <button className="btn btn-blue" onClick={this.handleDelete}>
                            Delete
                        </button>
                    </DialogActions>
                </Dialog>

                <ToastContainer  autoClose={3000}/>

            </div>
        )
    }
}

export default Users;

function appendLeadingZeroes(n) {
    if (n <= 9) {
        return "0" + n;
    }
    return n
}